/**
 * Open / Close hamburger menu.
 *
 * @returns {{init: init}}
 */
const NavClick = (() => {
  const DOM = {};

  let isMobile = window.matchMedia("only screen and (max-width: 990px)").matches;

  const cacheDOM = () => {
    DOM.hamburger = document.getElementsByClassName("hamburger-inner");
    DOM.menu = document.getElementsByClassName("header__nav");
    DOM.submenu = document.getElementsByClassName("menu-item-has-children");
  };

  const openMenu = () => {
    let button = DOM.hamburger[0];
    let container = DOM.menu[0];

    if (isMobile) {
      if (!button.classList.contains('active')) {
        button.classList.add('active');
        container.classList.add('active');

        container.style.height = 'auto';
        let height = container.clientHeight + "px";

        container.style.height = '0px';

        setTimeout(() => {
          container.style.height = height;
        }, 0);

      } else {
        container.style.height = '0px';
        button.classList.remove('active');

        container.addEventListener('transitionend',  () => {
          container.classList.remove('active');
        }, {
          once: true
        });

        for (let i = 0; i < DOM.submenu.length; i += 1) {
          DOM.submenu[i].classList.remove('active')
        }
      }
    }
  };

  const subMenu = (e) => {
    const parent = e.target.parentElement;
    const nav = DOM.menu[0];

    if (!parent.classList.contains('active') && parent.classList.contains('menu-item-has-children')) {
      e.preventDefault();
      parent.classList.add('active');

      let mainHeight = nav.offsetHeight + parent.offsetHeight - parent.children[0].offsetHeight;

      nav.style.height =  mainHeight + "px";
    } else {
      parent.classList.remove('active');
    }
  };

  const closeNav = () => {
    DOM.hamburger[0].classList.remove('active');
    DOM.menu[0].classList.remove('active');

    for (let i = 0; i < DOM.submenu.length; i += 1) {
      DOM.submenu[i].classList.remove('active')
    }
  }

  const eventListeners = () => {

    DOM.hamburger[0].addEventListener('click', () => {
      openMenu();
    });

    if (isMobile) {
      for (let i = 0; i < DOM.submenu.length; i += 1) {
        DOM.submenu[i].addEventListener("click", subMenu);
      }
    }

    window.addEventListener(
      "resize",
      function(){
        closeNav();
        isMobile = window.matchMedia("only screen and (max-width: 990px)").matches;

        if (isMobile) {
          for (let i = 0; i < DOM.submenu.length; i += 1) {
            DOM.submenu[i].addEventListener("click", subMenu);
          }
        }
      }
    );
  };

  const init = () => {
    cacheDOM();
    eventListeners();
  };

  return {
    init
  };
})();

export default NavClick;
